import { getConfig } from '../../config/query'

export type SupportedCurrencies = string[]
export const getPartnerCurrencies = getConfig<'supported_currencies', SupportedCurrencies>('supported_currencies')
